import React from "react";
import Home from "./components/Home";
import { ToastContainer } from "react-toastify";

function App() {
  return (
    <div>
      <Home />
      <ToastContainer />
    </div>
  );
}
export default App;
